import getConfig from "next/config";

import LockerCardSchedule from "@components/Lockers/LockerCard/LockerCardSchedule";
import LockerCardSaveOrDeleteAction from "@components/Lockers/LockerCard/LockerCardSaveOrDeleteAction";
import SelectedLockerMarkerIcon from "@components/Icons/Lockers/SelectedLockerMarkerIcon";
import LockerCardName from "@components/Lockers/LockerCard/LockerCardName";
import LockerCardAddress from "@components/Lockers/LockerCard/LockerCardAddress";
import LockerCardInactiveTag from "@components/Lockers/LockerCard/LockerCardInactiveTag";
import { FAVOURITE_LOCKER_INACTIVE_MESSAGE } from "@components/Lockers/_lib/constants";
import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";
import Alert from "@components/Alert";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// the icon default is the altex red, so brico passes its own brand red (red.brand)
const markerColor = isBricoStore ? "#DA281A" : undefined;

const FavouriteLockerView = ({ locker, onSaveOrDeleteFavouriteLocker }) => (
  <>
    <div className="text-[16px] flex items-center space-x-[4px]">
      <SelectedLockerMarkerIcon color={markerColor} />

      <LockerCardName locker={locker} />

      <LockerCardInactiveTag locker={locker} />
    </div>

    <LockerCardAddress locker={locker} />
    <LockerCardSchedule />

    {isLockerInactive(locker) && (
      <div className="mt-[6px]">
        <Alert type="warning" showIcon hasMinWidth={false}>
          {FAVOURITE_LOCKER_INACTIVE_MESSAGE}
        </Alert>
      </div>
    )}

    {/* Deleting the favourite is the way out of an inactive locker, so it always stays enabled */}
    <div className="py-[6px] border-t border-[#E5E5E5] mt-[6px]">
      <LockerCardSaveOrDeleteAction
        onSaveOrDeleteFavouriteLocker={onSaveOrDeleteFavouriteLocker}
        isFavourite={true}
      />
    </div>
  </>
);

export default FavouriteLockerView;
